import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Select from "react-select";

function Filtermodal({
  networklist,
  onDismiss,
  selNetwork,
  setSelNetwork,
  categoryList,
  setSelCat,
  selCat,
  min,
  setMin,
  max,
  setMax,
}) {
  const [filtersmodal, setFiltersmodal] = useState(true);

  const [selectedOption, setSelectedOption] = useState(null);
  const [isSearchable, setIsSearchable] = useState(true);
  const [options, setOption] = useState([
    { id: "all", label: "All" },
  ]);

  const [selectedcategoryOption, setSelectedcategoryOption] = useState(null);
  const [isSearchablecategory, setIsSearchablecategory] = useState(true);
  const [optionscategory, setOptionsCategory] = useState([
    { value: "coin categories", label: "coin categories" },
    { value: "game coins", label: "game coins" },
    { value: "meme coins", label: "meme coins" },
  ]);
  console.log("optionscategory-->", optionscategory);
  useEffect(() => {
    if (networklist.length > 0) {
      setOption([...options,
        ...(networklist.map((val) => {
          return { id: val._id, label: val.name };
        }))]
      );
    }
    if (categoryList.length > 0) {
      console.log("🚀 ~ useEffect ~ categoryList:", categoryList);
      setOptionsCategory(
        categoryList.map((val) => {
          return { id: val._id, label: val.name };
        })
      );
    }
  }, [networklist, categoryList]);

  return (
    <div>
      <Modal
        show={filtersmodal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton onClick={() => onDismiss()}></Modal.Header>
        <Modal.Body>
          <h4 className="mb-4 d_white">Filters</h4>
          <Row className="align-items-center">
            <Col xs={4} className="mb-3">
              <p className="mb-0 d_white">Network</p>
            </Col>
            <Col xs={8} className="mb-3">
              <Select
                className="mt-2 mt-sm-0"
                classNamePrefix="select"
                defaultValue={selNetwork}
                onChange={setSelNetwork}
                options={options}
                placeholder="All Network"
                isSearchable={isSearchable}
                // menuIsOpen={true}
              />
            </Col>
            {/* <Col xs={4} className="mb-3">
              <p className="mb-0 d_white">Category</p>
            </Col>
            <Col xs={8} className="mb-3">
              <Select
                className="mt-2 mt-sm-0"
                classNamePrefix="select"
                defaultValue={selCat}
                onChange={setSelCat}
                options={optionscategory}
                placeholder="All Category"
                isSearchable={isSearchablecategory}
                // menuIsOpen={true}
              />
            </Col> */}
            <Col xs={4} className="mb-3">
              <p className="mb-0 d_white">Price (24 Hr)</p>
            </Col>
            <Col xs={8} className="mb-3">
              <div className="d-flex gap-2">
                <div class="input-group mb-3">
                  <input
                    type="text"
                    onChange={(e) => setMin(e.target.value)}
                    class="form-control"
                    placeholder="Min"
                  />
                  <span class="input-group-text">$</span>
                </div>
                <div class="input-group mb-3">
                  <input
                    type="text"
                    onChange={(e) => setMax(e.target.value)}
                    class="form-control"
                    placeholder="Max"
                  />
                  <span class="input-group-text">$</span>
                </div>
              </div>
            </Col>
          </Row>
          <div className="text-end mb-2">
            <button
              onClick={() => onDismiss(true)}
              className="themebtn rounded-1 py-2 px-3"
            >
              Apply
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Filtermodal;
